import styled, { css } from 'styled-components/macro';
import { CustomScroll } from '@yme/atoms/custom-scroll';
import { MiniButton } from '@yme/atoms/mini-button';
import { Link } from '@yme/components/Link';
import { colorBrandYamahaRed, colorCoreBlack900Base, colorCoreGray500, colorCoreGray600, } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { ADAPTIVE } from '@yme/tokens/screen';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { getTextStyles } from '@yme/utils/styles';
export const WrapperStyled = styled.div `
  margin-top: 16px;
`;
export const ProductPartTitleStyled = styled(RegularTextLevel3) `
  margin-bottom: 4px;
`;
export const ProductPartContainerStyled = styled.div `
  margin-top: 16px;
  border: 1px solid ${colorCoreGray500};
  border-radius: ${CORNER_RADIUS.s};
`;
export const ScrollableContainer = styled.div `
  ${CustomScroll};

  width: ${({ hasScroll }) => (hasScroll ? 'calc(100% + 6px)' : '100%')};
  max-height: 486px;
  border: none;
`;
export const ImageWrapper = styled(Link) `
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  box-sizing: border-box;
  width: ${({ width }) => width};
  height: ${({ width }) => width};

  border: 1px solid ${colorCoreGray600};
`;
export const ProductPartInfo = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-grow: 1;

  ${({ isRightToLeft }) => (isRightToLeft ? 'margin-left: 4px;' : 'margin-right: 4px;')}
`;
export const ProductPartName = styled(Link) `
  margin-bottom: auto;

  ${getTextStyles('Ubuntu', null, 14, 20)}

  color: ${colorCoreBlack900Base};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  ${ADAPTIVE.minWidth.desktop} {
    ${getTextStyles('Ubuntu', null, 16, 24)}
  }
`;
export const LinkStyled = styled(Link) `
  margin-bottom: 4px;
  ${getTextStyles('Ubuntu', null, 14, 20)}

  white-space: nowrap;
  color: ${colorCoreBlack900Base};

  ${ADAPTIVE.minWidth.desktop} {
    ${getTextStyles('Ubuntu', null, 16, 24)}
  }
`;
export const MiniButtonStyled = styled(MiniButton) `
  padding: 7px;
  border-radius: 50%;
  text-transform: uppercase;

  ${({ isWithText }) => isWithText &&
    css `
      border-radius: 18px;
      padding: 8px 16px;
    `}
`;
export const StrikethroughTextStyled = styled.s `
  display: block;
  position: relative;
  text-align: right;
  padding: 4px 0 0;
  ${getTextStyles('Ubuntu', null, 12, 16)}
  color: ${colorBrandYamahaRed}
`;
